import {theme as base} from '@chakra-ui/react'
import {FontTheme} from '../types/typography.types'

const fonts: FontTheme = {
    fonts: {
        heading: `'DeLonghiSerif', 'Noto Sans', ${base.fonts?.heading}`,
        body: `'DeLonghiSans', 'Noto Sans', ${base.fonts?.body}`,
        primary: `'DeLonghiSerif', 'Noto Sans', ${base.fonts?.heading}`,
        secondary: `'DeLonghiSans', 'Noto Sans', ${base.fonts?.body}`,
    },
}

export default fonts
